import React from "react";
import { Button } from "react-bootstrap";
import { MessageType } from "../../../../../Constant";
import validateDepot from "../../validator/depotValidator";
import Select from "react-select";
import { fetchVehicleMaster, createMasterData, getAllDepotTypes } from "../../../../../services/vehicleMasterService";
import PropTypes from "prop-types";

export class DepotCreate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            form: {},
            stayOpen: false,
            removeSelected: true,
            rtl: false,
            disabled: false,
            citiesOptions: [],
            selectedCity: null,
            validDepot: true,
            depotTypeOptions: [],
            selectedDepotType: null
        };
        this.onCityChange = this.onCityChange.bind(this);

    }

    componentDidMount() {
        this.mounted = true;
        this.updateFormErrorState();
        this.fetchMasterData('city', null);
        this.fetchDepotTypes();
        if (this.props.updateSelection) {
            let data = this.props.updateSelection
            this.setState({
                depot: data.name ? data.name : '',
                radius: data.radius ? data.radius : '',
                latitude: data.latitude ? data.latitude : '',
                longitude: data.longitude ? data.longitude : '',
                id: data.id ? data.id : '',
                selectedDepotType: data.depotType ? { label: data.depotType, value: data.depotType } : null
            }, () => {
                this.updateFormErrorState()
            })
        }
    }

    fetchDepotTypes() {
        getAllDepotTypes()
            .then((response) => {
                if (!Array.isArray(response)) return;
                const depotTypeOptions = response.map((el) => ({
                    label: el,
                    value: el,
                }));
                this.setState({ depotTypeOptions });
            })
            .catch(() => {
                this.props.initiateNotification({
                    type: 'error',
                    message: 'Error while fetching depot types'
                });
            });
    }

    fetchMasterData(masterType, masterParentId) {
        fetchVehicleMaster(masterType, masterParentId, 0, 1000).then((res => {
            if (this.mounted) {
                switch (masterType) {
                    case 'city': {
                        this.setState({
                            citiesOptions: res.content.map(data => ({
                                label: data.name,
                                value: data
                            })),
                        }, () => {
                            if (this.props.updateSelection) {
                                let city = this.props.updateSelection.city;

                                this.setState({
                                    selectedCity: this.state.citiesOptions ? this.state.citiesOptions.find(val => {
                                        return val.label === city.name
                                    }) : []
                                }, () => {
                                    this.updateFormErrorState()
                                })

                            }
                        })
                    } break;

                }
            }

        })).catch(err => {
            if ((err.status === 401 || err.message === 'Invalid token')) {
                this.props.onComplete(MessageType.ERROR, ("Invalid token"));
            } else if (this.mounted) {
                this.setState({ citiesOptions: [] });
                this.props.initiateNotification({
                    type: 'error',
                    message: err.description ? err.description : "Error while fetching cities"
                });
            }
        }
        );
    }



    /**
     *on city change reset depot
     *
     */
    onCityChange(value) {
        this.setState({
            selectedCity: value
        }, () => {
            this.updateFormErrorState()
        });

    }


    render() {
        return (
                <form className="row">
                    <div className="col-sm-12 form-group mb-3">
                        
                            <label htmlFor="name7"
                                className="control-label col-sm-2 form-label"><span>City</span></label>
                            <div className="col-sm-10">
                                {!this.props.updateSelection && <Select
                                    closeOnSelect={!this.state.stayOpen}
                                    isClearable={false}
                                    onChange={(value) => {
                                        this.onCityChange(value)
                                    }}
                                    options={this.state.citiesOptions}
                                    placeholder="Select City"
                                    rtl={this.state.rtl}
                                    value={this.state.selectedCity}
                                />}
                                {this.props.updateSelection && <span className="detail">{this.props.updateSelection.city.name}</span>}

                            </div>
                    </div>

                    <div className="col-sm-12 form-group mb-3">
                        
                            <label htmlFor="name7"
                                className="control-label col-sm-2 form-label">Depot Type</label>
                            <div className="col-sm-10">
                                <Select
                                    closeOnSelect={!this.state.stayOpen}
                                    isClearable={true}
                                    onChange={(value) => {
                                        this.setState({ selectedDepotType: value }, () => {
                                            this.updateFormErrorState()
                                        })
                                    }}
                                    options={this.state.depotTypeOptions}
                                    placeholder="Select Depot Type"
                                    rtl={this.state.rtl}
                                    value={this.state.selectedDepotType}
                                />
                            </div>
                    </div>

                    <div className="col-sm-12 form-group mb-3">
                        
                            <label htmlFor="name7"
                                className="control-label col-sm-2 form-label"><span>Depot</span></label>
                            <div className="col-sm-10 ">
                                <input type="text" autoComplete="off" className="form-control" id="depot"
                                    placeholder="Enter Depot"

                                    disabled={!this.state.selectedCity}
                                    onChange={(value) => {
                                        this.setState({ depot: value.target.value.trim() }, () => {
                                            this.updateFormErrorState()
                                        })
                                    }}
                                    readOnly={this.props.updateSelection}

                                    defaultValue={this.props.updateSelection ? this.props.updateSelection.name : ""}

                                />
                                {!this.state.validDepot && <span className="error-text">Invalid depot name</span>}

                            </div>
                    </div>
                    <div className="col-sm-12 form-group mb-3">
                        
                            <label htmlFor="name7"
                                className="control-label col-sm-2 form-label">Radius</label>
                            <div className="col-sm-10 ">
                                <input type="text" autoComplete="off" className="form-control" id="radius"
                                    placeholder="Enter radius in meters"

                                    onChange={(value) => {
                                        this.setState({ radius: value.target.value.trim() }, () => {
                                            this.updateFormErrorState()
                                        })
                                    }}
                                    onKeyDown={(value) => {
                                        this.preventAlphaCharacter(value, value.key);
                                    }}
                                    onPaste={(value) => {
                                        this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData('Text'));
                                    }}
                                    defaultValue={this.props.updateSelection ? this.props.updateSelection.radius : ""}

                                />

                            </div>
                    </div>
                    <div className="col-sm-12 form-group mb-3">
                        
                            <label htmlFor="name7"
                                className="control-label col-sm-2 form-label">Latitude</label>
                            <div className="col-sm-10 ">
                                <input type="text" autoComplete="off" className="form-control" id="latitude"
                                    placeholder="Enter latitude"

                                    onChange={(value) => {
                                        this.setState({ latitude: value.target.value.trim() }, () => {
                                            this.updateFormErrorState()
                                        })
                                    }}
                                    onKeyDown={(value) => {
                                        this.preventAlphaCharacter(value, value.key);
                                    }}
                                    onPaste={(value) => {
                                        this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData('Text'));
                                    }}
                                    defaultValue={this.props.updateSelection ? this.props.updateSelection.latitude : ""}

                                />
                            </div>
                    </div>
                    <div className="col-sm-12 form-group mb-3">
                        
                            <label htmlFor="name7"
                                className="control-label col-sm-2 form-label">Longitude</label>
                            <div className="col-sm-10 ">
                                <input type="text" autoComplete="off" className="form-control" id="longitude"
                                    placeholder="Enter longitude"

                                    onChange={(value) => {
                                        this.setState({ longitude: value.target.value.trim() }, () => {
                                            this.updateFormErrorState()
                                        })
                                    }}
                                     onKeyDown={(value) => {
                                                this.preventAlphaCharacter(value, value.key);
                                            }}
                                            onPaste={(value) => {
                                                this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData('Text'));
                                            }}
                                    defaultValue={this.props.updateSelection ? this.props.updateSelection.longitude : ""}

                                />

                            </div>
                    </div>
                    <div className="col-sm-12 form-view">
                        <Button onClick={() => this.props.onClose()} bsPrefix="close-btn">Close</Button>
                        <Button bsPrefix="confirm-btn"
                            onClick={() => {
                                this.setState({ loading: true })
                                this.createDepotMaster()
                            }}
                            disabled={this.state.form.invalid || this.state.loading}
                        >{this.state.loading ? 'Saving...' : 'Save changes'}</Button>
                    </div>
                </form>)
    }

    /**
     * validates Depot form data
     * @param target
     */
    updateFormErrorState() {
        let formState = validateDepot(this.state);
        this.setState({
            form: formState
        }, () => {
            this.state.form.depotNameError ? this.setState({
                validDepot: false
            }) : this.setState({
                validDepot: true
            });
        });
    }


    /**
     * Used to Create Depot Master
     */
    createDepotMaster() {
        let data = {
            name: this.state.depot.toUpperCase(), city: { id: this.state.selectedCity.value.id },
            latitude: this.state.latitude ? this.state.latitude : '',
            longitude: this.state.longitude ? this.state.longitude : '',
            radius: this.state.radius ? this.state.radius : '',
            depotType: this.state.selectedDepotType ? this.state.selectedDepotType.value : null
        }

        if (this.props.updateSelection) {
            data['id'] = this.state.id
        }
        createMasterData('depot', data, this.props.updateSelection).then((response) => {
            if (this.mounted) {
                this.setState({ loading: false });
                this.props.onComplete(MessageType.SUCCESS, "Successfully done ");
            }
        }).catch((err) => {
            this.props.onComplete(MessageType.ERROR, (err.description ? err.description : "Error occurred "));
        });
    }

    preventAlphaCharacter(event, value) {
        const allowedKeys = [
            'Backspace',
            'Delete',
            'ArrowLeft',
            'ArrowRight',
            'Tab',
            'Home',
            'End'
        ];

        if (allowedKeys.includes(event.key)) {
            return;
        }

        const re = /^-?\d*\.?\d*$/; // NOSONAR
        if (!re.test(value)) {
            event.preventDefault();
        }
        }
        componentWillUnmount() {
            this.mounted = false;
        }
    }


DepotCreate.propTypes = {
  onClose: PropTypes.func,
  onComplete: PropTypes.func,
  initiateNotification: PropTypes.func,
  updateSelection: PropTypes.object,
};